import { render } from "./profile-actions.vue?vue&type=template&id=ded71174"
import script from "./profile-actions.vue?vue&type=script&lang=js"
export * from "./profile-actions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__